import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton } from '../../../base/buttons';
import { translate } from '../../../base/i18n';
import { isCheckPermission } from '../../../base/localuser/functions';
import { PERMISSION } from '../../../base/participants';
import { setVideoLayoutProperty } from '../../../video-layout-mode';

function SwitchDualMonitorButton({ t }) {
    if (!APP.layout.option.dualMonitor) return null;

    const isDualPermission = useSelector(state => isCheckPermission(state, PERMISSION.DUAL));
    if (!isDualPermission) return null;
    
    const dispatch = useDispatch();
    const isDualMonitor = useSelector(state => state['features/video-layout-mode'].isDualMonitor);
    
    const onClick = () => {
        if (APP.mateManagement.getScreenSharing()) {
            alert('화면 공유 중에 듀얼 모니터 사용 할 수 없습니다.'); 
            return;
        }
        dispatch( setVideoLayoutProperty({ isDualMonitor: !isDualMonitor }) );
        APP.UI.closeModal();
    };

    return (
        <IconButton mode="dual" name={t(`options.${isDualMonitor}DualMonitor`)} size={22} onClick={onClick} />
    );
}

export default translate(SwitchDualMonitorButton);
